export default [
  {
    meta: {
      authorizedIf: [{ isSignedIn: true }],
      layout: 'blue',
    },
    name: 'messungen-screening',
    path: '/messungen/screening',
    component() {
      return import('@/views/assessments/Pre.vue')
    },
  },
  {
    meta: {
      authorizedIf: [{ isSignedIn: true }],
      layout: 'blue',
    },
    name: 'messungen-post',
    path: '/messungen/post',
    component() {
      return import('@/views/assessments/Post.vue')
    },
  },
  {
    meta: {
      authorizedIf: [{ isSignedIn: true }],
      layout: 'blue',
    },
    name: 'messungen-fu1',
    path: '/messungen/fu1',
    component() {
      return import('@/views/assessments/FU1.vue')
    },
  },
  {
    meta: {
      authorizedIf: [{ isSignedIn: true }],
      layout: 'blue',
    },
    name: 'messungen-fu2',
    path: '/messungen/fu2',
    component() {
      return import('@/views/assessments/FU2.vue')
    },
  },
]
